<template>
  <panel title="Search By Client">
    <v-flex>
	<v-text-field 
		v-model="search" 
		label="Search by client name"/>
		</v-flex>
  </panel>
</template>

<script>
import _ from 'lodash'
import EventBus from '@/main'
import {mapState} from 'vuex'

export default {
	props: {
		route: {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			search: ''
		}
	},
	watch: {
		search: _.debounce(async function (value) {
			const route = {
				name: this.route
			}
			if (this.search !== '') {
				route.query = {
					search: this.search
				}
			}
			this.$router.push(route)
		}, 700),
		'$route.query.search': {
			immediate: true,
			handler (value) {
				this.search = value
			}
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Clients/ClientsSearchPanel.vue